<template>
    <div class="retailer-results-wrap container" v-if="store.locations.length">
        <GoogleMap
            api-key="AIzaSyDBqMRtUiJedMgsZjwpPTOKGfKoW11xbwI"
            :center="store.coords"
            :zoom="10"
            class="themap"
            style="width:100%; height:400px;"
            map-type-id="roadmap"
            :styles="mapStyles"
            ref="map"
        >
            <Marker v-for="l in store.locations" :key="l.ID" :options="getMarkerOptions(l)">
                <InfoWindow class="map-marker">
                    <div class="content">
                        <h2 class="title">{{ l.Name }}</h2>
                        <address>
                            {{ l.Address }}<br/>
                            {{ l.City }} {{ l.State }}, {{  l.Zip }}
                        </address>
                        <a :href="googleLink(l)" target="_blank"> {{ $filters.distance(l.Distance) }} - Get Directions</a>
                    </div>
                </InfoWindow>
            </Marker>
        </GoogleMap>

        <ul class="locations">
            <li v-for="l in store.locations" :key="l.ID">
                <h2 class="title">{{ l.Name }}</h2>
                <address>
                    {{ l.Address }}<br/>
                    {{ l.City }} {{ l.State }}, {{  l.Zip }}
                </address>
                <span class="distance">
                    {{ $filters.distance(l.Distance) }}<br/>
                </span>
                <a :href="googleLink(l)" target="_blank" class="btn red">Get Directions</a>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { GoogleMap, InfoWindow, Marker } from "vue3-google-map";
import { ref } from 'vue';
import { useRetailersStore } from '@stores/retailers';
const store = useRetailersStore();

const map = ref(null);

const mapStyles = [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}];

const getMarkerOptions = (l) => {
    return {
        position: {
            lat:parseFloat(l.Latitude),
            lng:parseFloat(l.Longitude)
        },
        icon: '/images/svg/map-marker.svg'
    }
}

const googleLink =  (marker) => {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(marker.Address+' '+marker.City+' '+marker.State+' '+marker.Zip);
}



</script>
